import { Routes, Route } from 'react-router-dom';
import MainPage from '../pages/MainPage/MainPage';
import TasksPage from '../pages/TasksPage/TasksPage';
import FriendsPage from '../pages/FriendsPage/FriendsPage';
import ProfilePage from '../pages/ProfilePage/ProfilePage';
import LeaderboardPage from "../pages/LeaderboardPage/LeaderboardPage.tsx";

export const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/tasks" element={<TasksPage />} />
      <Route path="/friends" element={<FriendsPage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/profile" element={<ProfilePage />} />
    </Routes>
  );
};
